import { AssetsViewType, AssetSystemFolder } from '../../tstypes/projects';

export const getAssetViewType = (viewType: string | AssetsViewType = AssetsViewType.card) =>
	viewType in AssetsViewType ? (viewType as AssetsViewType) : AssetsViewType.card;

export const getFolderID = (folderID: string = AssetSystemFolder.all) =>
	folderID in AssetSystemFolder ? (folderID as AssetSystemFolder) : folderID;
